import { MaintenanceRequester, type UpcomingMaintenancesByStatus } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'sonner';
import { loadUpcomingMaintenancesRequest, loadUpcomingMaintenancesSucceeded, loadUpcomingtMaintenancesFailed } from './actionCreators';
import type { DeleteRemindersRequest, EditRemindersRequest, SetupRemindersRequest } from './actions';
import { ActionTypes } from './actionTypes';

const env = Environment.getInstance().getEnvironment();

export const maintenanceRequester = new MaintenanceRequester({
  host: env.herbieApiHost,
});

export function* requestUpcomingMaintenancesSaga() {
  try {
    const upcoming: UpcomingMaintenancesByStatus = yield call(maintenanceRequester.loadUpcomingMaintenances);
    yield put(loadUpcomingMaintenancesSucceeded(upcoming));
  } catch (err) {
    yield put(loadUpcomingtMaintenancesFailed());
    toast.error('Falha ao carregar avisos de manutenção. Tente novamente mais tarde.');
  }
}

export function* requestEditRemindersSaga(action: EditRemindersRequest) {
  try {
    yield call(maintenanceRequester.editReminders, action.payload.vehicleId, action.payload.recurrences);
    toast.success('Recorrências editadas com sucesso!');
    yield put(loadUpcomingMaintenancesRequest());
  } catch (err) {
    toast.error('Falha ao editar recorrências.');
  }
}

export function* requestDeleteRemindersSaga(action: DeleteRemindersRequest) {
  try {
    yield call(maintenanceRequester.deleteReminders, action.payload);
    toast.success('Lembretes descadastrados com sucesso!');
    yield put(loadUpcomingMaintenancesRequest());
  } catch (err) {
    toast.error('Falha ao descadastrar lembretes de manutenção.');
  }
}

export function* requestSetupRemindersSaga(action: SetupRemindersRequest) {
  try {
    yield call(maintenanceRequester.setupMaintanenceReminders, action.payload);
    toast.success('Lembretes salvos com sucesso!');
    yield put(loadUpcomingMaintenancesRequest());
  } catch (err) {
    toast.error('Falha ao salvar lembretes de manutenção.');
  }
}

export function* UpcomingMaintenancesSagasListener() {
  yield all([
    takeLatest(ActionTypes.LOAD_UPCOMING_MAINTENANCES_REQUEST, requestUpcomingMaintenancesSaga),
    takeLatest(ActionTypes.EDIT_REMINDERS_REQUEST, requestEditRemindersSaga),
    takeLatest(ActionTypes.DELETE_REMINDERS_REQUEST, requestDeleteRemindersSaga),
    takeLatest(ActionTypes.SETUP_REMINDERS_REQUEST, requestSetupRemindersSaga),
  ]);
}
